import React, { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Link } from 'react-router-dom';
import { Badge, Modal, Dropdown, Tab, Tabs, Button, Form, Stack } from 'react-bootstrap';

import { faPlus, faXmark, faCircle, faPaperclip, faPencil, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';

import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../../Components/TopMenu/TopMenu';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import edit from "../../../../assets/images/edit.png";
import Export from "../../../../assets/images/export.svg";
import EmailGreen from "../../../../assets/images/recover_email.png";
import EmailRed from "../../../../assets/images/pending_email.png";
import { GETCONDITIONCODE, GETDESTINATION, GETOWNERCODE, GETULDDETAILS, MVTHDETAILS, ULDSETRECOVERY, UPDATERECOVERY } from '../../../../Utils/conts';
import { withRFSToken } from '../../../../Services/axios.js';
import { toast } from 'react-toastify';
import DownloadGrid from '../components/DownloadGrid.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

function Demurrage() {
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);

    const [gridData, setGridData] = useState([]);

    const gridRef = useRef(null);

    useEffect(() => {
        if (isMounted.current) return;

        setIsLoading(false);
        setGridData({ Active: {} });
        isMounted.current = true;
    }, []);

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef.current) {
            // let token = "Bearer " + localStorage.ULD;

            jqxCookieCall()

            const source = {
                datatype: "json",
                id: "",
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: "uld_number", type: "string" },
                    { name: "type_code", type: "string" },
                    { name: "serial_number", type: "string" },
                    { name: "owner_code", type: "string" },
                    { name: "luc_final_dest", type: "string" },
                    { name: "received_by_name", type: "string" },
                    { name: "td_demmurage", type: "string" },
                    { name: "luc_out", type: "string" },
                    { name: "returned_on", type: "string" },
                ],
                url: `${process.env.REACT_APP_RFS_URL}demurrage-data`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader("Authorization", token);
                // },
                pagesize: 20,
                filter: function (allfilters) {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.total_data;
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);

            // Adding select options (checkedlist) for certain columns
            const columns = [
                { text: "ULD Number", filtertype: "textbox", datafield: "uld_number", width: "12%" },
                { text: "Type Code", filtertype: "textbox", datafield: "type_code", width: "10%" }, // Select option added
                { text: "Serial Number", filtertype: "textbox", datafield: "serial_number", width: "12%" },
                { text: "Owner Code", filtertype: "textbox", datafield: "owner_code", width: "10%" }, // Select option added
                { text: "Station", filtertype: "textbox", datafield: "luc_final_dest", width: "10%" }, // Select option added
                { text: "Agent", filtertype: "textbox", datafield: "received_by_name", width: "10%" }, // Select option added
                { text: "Total day's Demmurage", filtertype: "textbox", datafield: "td_demmurage", width: "10%" },
                { text: "On Loan Since", filtertype: "textbox", datafield: "luc_out", width: "12%" },
                { text: "Returned On", filtertype: "textbox", datafield: "returned_on", width: "12%" },
            ];

            const gridOptions = {
                width: "100%",
                source: dataAdapter,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ["20", "50", "100", "200", "500"],
                pagerButtonsCount: 5,
                pagerMode: "advanced",
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                rowdetails: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };

            window.$(gridRef.current).jqxGrid(gridOptions);

            window.$(gridRef.current).find(".jqx-grid-column-header").css("background-color", "white");

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on("mouseover", () => {
                    window.$(row).addClass("row-hover");
                });
                window.$(row).on("mouseout", () => {
                    window.$(row).removeClass("row-hover");
                });
            });
        }
    }, [gridData]);

    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);
    };

    const loadDetails = async (uldNumber, missingId, forFound) => {
        try {
            const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber, missing_id: missingId })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (forFound) {
                        // setFoundData(innerData);
                        // setChangeData(innerData);
                        // setMissingModal(true);
                        // setFormData(innerData.movement_history[0]);
                        // fetchOwnerCode();
                        // fetchCondCode();
                        // fetchDestination();
                    } else {
                        // setSelectedRowData(innerData);
                    }

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const handleCloseClick = () => {
        // setSelectedRowData(null);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    return (
        <>
            {downloadOpen && <DownloadGrid download_area='bt' download_sec={'demurrage'} onClose={closeDownloadModal} />}
            <div className='lcontent'>
                <div className="mb-3 nestedtabs rounded minh">
                    <div className='d-flex'>
                    </div>
                </div>
                <div className='ulddown'>
                    <button onClick={showDownloadModal}><img src={Export} /> Download</button>
                </div>

                <div className="maindiv">
                    <div className='trashdonload'>
                        {!isLoading && (
                            <>
                                <div ref={gridRef} className="bookinggrid"></div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Demurrage